import React, { useState,useEffect } from 'react';
import { useNavigate } from "react-router";
import { title } from "../config";
import AppMenu from "../components/AppMenu";
import { Alert, Button, Table } from 'reactstrap';
import { deleteProcess, getProcessData, getAllProcess } from '../services/processAPI';

const Processes = () => {
    const [tableData, setTableData] = useState([]);
    // this should come from DB 
    const processes =  getAllProcess();

    useEffect(() => {
        reloadProcess();
      }, []);
    
      const reloadProcess = async () => {
        let records = await getProcessData();
        setTableData( records);
      };
    const navigate = useNavigate();
    const doEdit = (id) => {
        navigate(`/process/edit/${id}`);
      };
      const doDelete = async (data) => {
        await deleteProcess(data);
        // reloadProcess();
      };
      const getFields = () => {
        if (tableData.length > 0) {
            return Object.keys(tableData[0]).filter(key => key !== '_id' && key !== 'lastUpdated' && key !== 'processName');
        }
        return [];
    };
    return (
        <div>
            <div className="px-2 sticky-header">
                <h3 className="m-0 p-2">{title} | Process</h3>
                <AppMenu />
            </div>
            <Button onClick={() => {navigate(`/process/add`)}}>Add New Process</Button>
            <div className="row m-lg-1">
                {processes.map((process, index) => (
                    <div key = {index} className="col-md-3 col-sm-12">
                    <Alert color="primary" className="p-3">
                        <h5>{process?.processName}</h5>
                        <div style={{ height: "100px", overflow: "auto" }}>
                        Steps: <a 
                                className="alert-link" 
                                class="fa-solid fa-file"
                                onClick={() => {
                                    navigate(`/process/${process?._id}/record/add`, { state: { process } });
                                  }}
                                style={{ cursor: "pointer"  }}
                            > 
                            </a> &nbsp;&nbsp;&nbsp; <a 
                                className="alert-link" 
                                class="fa-solid fa-clipboard"
                                onClick={() => {
                                    navigate(`/process/${process?._id}/record/add`, { state: { process } });
                                  }}
                                style={{ cursor: "pointer"  }}
                            > 
                            </a>
                            <br/>
                            Verify: <a 
                                className="alert-link" 
                                class="fa-solid fa-file"
                                onClick={() => {
                                    navigate(`/process/${process?._id}/record/add`, { state: { process } });
                                  }}
                                style={{ cursor: "pointer"  }}
                            >
                            </a>&nbsp;&nbsp;&nbsp; <a 
                                className="alert-link" 
                                class="fa-solid fa-clipboard"
                                onClick={() => {
                                    navigate(`/process/${process?._id}/record/add`, { state: { process } });
                                  }}
                                style={{ cursor: "pointer"  }}
                            > 
                            </a>
                            
                            
                        </div>
                    </Alert>
                    </div>
                ))}
            </div>

            {/* Unified Table */}
            {tableData.length > 0 ? (
            <Table className="table table-hover mt-4" responsive hover>
                <thead>
                    <tr>
                        <th>Process Name</th>
                        {getFields().map((field, index) => (
                            <th key={index} className="cursor-pointer">{field}</th>
                        ))}
                        <th>Last Updated</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => (
                        <tr key={index}>
                            <td>{data.processName}</td>
                            {getFields().map((field, idx) => (
                                <td key={idx}>
                                    {typeof data[field] === 'boolean' ? (data[field] ? "Yes" : "No") : data[field]}
                                </td>
                            ))}
                            <td>{data.lastUpdated}</td>
                            <td className="d-flex">
                                <i
                                    className="fas fa-edit btn btn-primary m-2"
                                    onClick={() => doEdit(data._id)}
                                    aria-hidden="true"
                                />
                                <i
                                    className="fa-solid fa-trash-can btn btn-danger m-2"
                                    onClick={() => doDelete(data._id)}
                                    aria-hidden="true"
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            ) : (
                <div className="text-center mt-4">
                    <h4>No records found.</h4>
                </div>
            )}
        </div>
    );
};

export default Processes;
